import 'preact/devtools'
import { App } from './app/app.js';
import './scss/index.scss';

const app = new App('body');
app.init();
